export default "__VITE_ASSET__CL5n$i4s__"